var L = /* @__PURE__ */ ((E) => (E[E.AVAILABLE = 1] = "AVAILABLE", E[E.PARTIALLY_AVAILABLE = 2] = "PARTIALLY_AVAILABLE", E[E.UNAVAILABLE = 19] = "UNAVAILABLE", E[E.UNCONFIRMED = 20] = "UNCONFIRMED", E[E.CONFIRMED = 21] = "CONFIRMED", E[E.REJECTED = 39] = "REJECTED", E))(L || {});
export {
  L as BookingAvailabilityStatus
};
//# sourceMappingURL=bookingAvailabilityStatus.enum.js.map
